import { Delete } from '@icons'
import cn from '@integrations/classnames'
import { tr } from 'mmfintech-commons'
import type { UseFormValuesOutput } from 'mmfintech-commons/types'
import { Input } from 'mmfintech-portal-commons'

interface Props {
  formValues: UseFormValuesOutput
  handleSave: () => void
  otherBranches: string[]
  otherBranchesError: string[]
  otherBranchesChange: (index: number, value: string) => void
  otherBranchesAdd: () => void
  otherBranchesRemove: () => void
}

function QuestionnaireFirstStep({
  formValues,
  handleSave,
  otherBranches,
  otherBranchesError,
  otherBranchesChange,
  otherBranchesAdd,
  otherBranchesRemove
}: Props) {
  return (
    <>
      <div className={cn('subtitle')}>
        {tr(
          'FRONTEND.QUESTIONNAIRE.KYB.PROVIDE_ADDITIONAL_INFORMATION',
          'Please provide additional business information and documents for us to be able'
        )}
      </div>
      <Input
        type='text'
        label={tr('FRONTEND.QUESTIONNAIRE.KYB.FULL_LEGAL_NAME', 'Full Legal Name')}
        {...formValues.registerInput('fullLegalName')}
        data-test='full-legal-name'
        onBlur={handleSave}
      />
      <Input
        type='text'
        label={tr('FRONTEND.QUESTIONNAIRE.KYB.COMPANY_TRADING_NAME', 'Company Trading Name')}
        {...formValues.registerInput('companyTradingName')}
        data-test='company-trading-name'
        onBlur={handleSave}
      />
      <Input
        type='text'
        label={tr('FRONTEND.QUESTIONNAIRE.KYB.COMPANY_REGISTRATION_NUMBER', 'Company Registration Number')}
        {...formValues.registerInput('companyRegistrationNumber')}
        data-test='company-registration-number'
        onBlur={handleSave}
      />
      <Input
        type='date'
        label={tr('FRONTEND.QUESTIONNAIRE.KYB.DATE_OF_INCORPORATION', 'Date of Incorporation')}
        {...formValues.registerInput('dateOfIncorporation')}
        inputProps={{ 'data-test': 'date-of-incorporation' }}
        onBlur={handleSave}
        placement='bottom-start'
        overlayClassName='no-arrow'
      />
      <Input
        type='text'
        label={tr('FRONTEND.QUESTIONNAIRE.KYB.REGISTER_ADDRESS', 'Registered Address')}
        {...formValues.registerInput('registeredAddress')}
        data-test='registered-address'
        onBlur={handleSave}
      />

      {otherBranches?.map((element, index) => (
        <Input
          key={index}
          type='text'
          value={element}
          error={otherBranchesError[index]}
          required={true}
          parentClassName='otherBranches'
          name={`other-branches-${index}`}
          label={index === 0 ? tr('FRONTEND.QUESTIONNAIRE.KYB.OTHER_BRANCHES', 'Other Branches') : null}
          placeholder={tr('FRONTEND.QUESTIONNAIRE.KYB.OTHER_BRANCHES', 'Other Branches')}
          onChange={(_name, value) => otherBranchesChange(index, value)}
          data-test='other-branches'
          hideErrorLine
          onBlur={handleSave}
        />
      ))}
      <div className={cn('add-and-remove-wrapper')}>
        <div className={cn('add')} onClick={() => otherBranchesAdd()} data-test='add'>
          {tr('FRONTEND.QUESTIONNAIRE.BUTTON_ADD', 'Add')}
        </div>
        {otherBranches.length > 1 ? (
          <div className={cn('remove')} onClick={() => otherBranchesRemove()} data-test='remove'>
            <div className={cn('remove-icon')}>
              <Delete />
            </div>
            <span>{tr('FRONTEND.QUESTIONNAIRE.BUTTON_REMOVE', 'Remove')}</span>
          </div>
        ) : null}
      </div>

      <Input
        type='text'
        label={tr('FRONTEND.QUESTIONNAIRE.KYB.INDICATE_TRADING_ADDRESS', 'Indicate if Trading Address is different')}
        {...formValues.registerInput('indicareIfTradingAddressIsDifferent')}
        data-test='indicate-if-trading-address-is-different'
        onBlur={handleSave}
      />
      <Input
        type='number'
        label={tr('FRONTEND.QUESTIONNAIRE.KYB.BUSINESS_TELEPHONE', 'Business Telephone')}
        {...formValues.registerInput('businessTelephone')}
        data-test='business-telephone'
        onBlur={handleSave}
      />
      <Input
        type='number'
        label={tr('FRONTEND.QUESTIONNAIRE.KYB.CUSTOMER_SERVICE_PHONE', 'Customer Service Phone')}
        {...formValues.registerInput('customerServicePhone')}
        data-test='customer-service-phone'
        onBlur={handleSave}
      />
      <Input
        type='text'
        label={tr('FRONTEND.QUESTIONNAIRE.KYB.BUSINESS_EMAIL_ADDRESS', 'Business Email Address')}
        {...formValues.registerInput('businessEmailAddress')}
        data-test='business-email-address'
        onBlur={handleSave}
      />
    </>
  )
}

export default QuestionnaireFirstStep
